import { withStyles } from '@material-ui/core';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';

import { expansionPanelSummaryStyles } from './expansion-panel-summary.styles';

export const ExpansionPanelSummary = withStyles(expansionPanelSummaryStyles)(
  MuiAccordionSummary
);
